var $70dc0a0cd1ed5f6e$exports = {};
// ======= Form submit =========
// ===============================
async function $70dc0a0cd1ed5f6e$var$loadCountryCodes() {
    try {
        const response = await fetch(`${"https://qkkalabs.com"}/blog/api/metadata?country_codes=true`);
        const data = await response.json();
        const countrySelect = document.getElementById("countryCode");
        // Clear existing options
        countrySelect.innerHTML = "";
        data.data.country_codes.forEach((country)=>{
            const option = document.createElement("option");
            option.value = country.value;
            option.textContent = country.label;
            option.dataset.code = country.value;
            option.dataset.label = country.label;
            countrySelect.appendChild(option);
        });
        // Default India selected
        countrySelect.value = "+91";
        // Show only code initially
        $70dc0a0cd1ed5f6e$var$collapseToCode();
    } catch (error) {
        console.error("Error loading country codes:", error);
    }
}
const $70dc0a0cd1ed5f6e$var$countrySelect = document.getElementById("countryCode");
let $70dc0a0cd1ed5f6e$var$lastOpenedAt = 0;
function $70dc0a0cd1ed5f6e$var$handleOpen() {
    $70dc0a0cd1ed5f6e$var$restoreLabels();
    $70dc0a0cd1ed5f6e$var$lastOpenedAt = Date.now();
}
function $70dc0a0cd1ed5f6e$var$handleCloseOrSelect() {
    if (Date.now() - $70dc0a0cd1ed5f6e$var$lastOpenedAt < 300) return;
    $70dc0a0cd1ed5f6e$var$collapseToCode();
}
function $70dc0a0cd1ed5f6e$var$restoreLabels() {
    Array.from($70dc0a0cd1ed5f6e$var$countrySelect.options).forEach((option)=>{
        option.textContent = option.dataset.label;
    });
}
function $70dc0a0cd1ed5f6e$var$collapseToCode() {
    $70dc0a0cd1ed5f6e$var$restoreLabels();
    const selectedOption = $70dc0a0cd1ed5f6e$var$countrySelect.options[$70dc0a0cd1ed5f6e$var$countrySelect.selectedIndex];
    if (selectedOption) selectedOption.textContent = selectedOption.dataset.code;
}
// Show full list while opening
$70dc0a0cd1ed5f6e$var$countrySelect?.addEventListener("mousedown", $70dc0a0cd1ed5f6e$var$handleOpen);
$70dc0a0cd1ed5f6e$var$countrySelect?.addEventListener("focus", $70dc0a0cd1ed5f6e$var$handleOpen);
// Show only code after selection, click, or blur
$70dc0a0cd1ed5f6e$var$countrySelect?.addEventListener("change", $70dc0a0cd1ed5f6e$var$collapseToCode);
$70dc0a0cd1ed5f6e$var$countrySelect?.addEventListener("blur", $70dc0a0cd1ed5f6e$var$collapseToCode);
$70dc0a0cd1ed5f6e$var$countrySelect?.addEventListener("click", $70dc0a0cd1ed5f6e$var$handleCloseOrSelect);
// Load dropdown
$70dc0a0cd1ed5f6e$var$loadCountryCodes();
// Usage in form submit
function $70dc0a0cd1ed5f6e$var$getCountryCode() {
    const selectedOption = $70dc0a0cd1ed5f6e$var$countrySelect.options[$70dc0a0cd1ed5f6e$var$countrySelect.selectedIndex];
    return selectedOption?.dataset.code || "";
}
// form submit function and captcha related code
// =============================================
let $70dc0a0cd1ed5f6e$var$savedCaptchaCode = "";
// CAPTCHA API LOAD
const $70dc0a0cd1ed5f6e$var$createCaptchaImage = async ()=>{
    const captchaBox = document.getElementById("captchaImage");
    if (captchaBox) captchaBox.innerHTML = '<div class="w-[9.375rem] h-[3.125rem] border border-white animate-pulse"></div>';
    try {
        const response = await fetch(`${"https://qkkalabs.com"}/blog/api/captcha`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("Captcha API failed");
        const result = await response.json();
        $70dc0a0cd1ed5f6e$var$savedCaptchaCode = result.captcha_0 || "";
        if (captchaBox) captchaBox.innerHTML = `
        <img
          src="${result.image_url?.replace('http:', 'https:')}"
          alt="captcha"
          class="h-[3.125rem] w-[8.375rem] object-contain rounded"
        />
      `;
    } catch (error) {
        console.error("Captcha Error:", error);
        if (captchaBox) captchaBox.innerHTML = '<div class="text-white text-xs">Captcha failed</div>';
    }
};
window.onload = ()=>$70dc0a0cd1ed5f6e$var$createCaptchaImage();
window.createCaptchaImage = $70dc0a0cd1ed5f6e$var$createCaptchaImage;
// HELPERS
const $70dc0a0cd1ed5f6e$var$focusField = (id)=>{
    const el = document.getElementById(id);
    if (el) {
        el.focus();
        return true;
    }
    return false;
};
// ===============================
// VALIDATIONS
// ===============================
const $70dc0a0cd1ed5f6e$var$validateName = (name)=>{
    if (!name || name.length < 3) {
        alert("Please enter a valid full name (at least 3 characters).");
        $70dc0a0cd1ed5f6e$var$focusField("fullName");
        return false;
    }
    return true;
};
const $70dc0a0cd1ed5f6e$var$validateCountryCode = (countryCode)=>{
    if (!countryCode) {
        alert("Please select a country code.");
        $70dc0a0cd1ed5f6e$var$focusField("countryCode");
        return false;
    }
    return true;
};
const $70dc0a0cd1ed5f6e$var$validatePhone = (phone)=>{
    const cleaned = (phone || "").replace(/\D/g, "");
    if (cleaned.length < 7 || cleaned.length > 15) {
        alert("Please enter a valid phone number (7 to 15 digits) with country code.");
        $70dc0a0cd1ed5f6e$var$focusField("Phone_number");
        return null;
    }
    return cleaned;
};
const $70dc0a0cd1ed5f6e$var$validateEmail = (email)=>{
    if (!email) {
        alert("Please enter your email address.");
        $70dc0a0cd1ed5f6e$var$focusField("email");
        return false;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!pattern.test(email)) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $70dc0a0cd1ed5f6e$var$focusField("email");
        return false;
    }
    // Count dots in the local part (before @)
    const localPart = email.split("@")[0];
    const dotCount = (localPart.match(/\./g) || []).length;
    if (dotCount > 2) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $70dc0a0cd1ed5f6e$var$focusField("email");
        return false;
    }
    return true;
};
const $70dc0a0cd1ed5f6e$var$validateCompany = (companyName)=>{
    if (!companyName || !companyName.trim()) {
        alert("Please enter your company name.");
        $70dc0a0cd1ed5f6e$var$focusField("company_name");
        return false;
    }
    return true;
};
const $70dc0a0cd1ed5f6e$var$validateCompanyName = $70dc0a0cd1ed5f6e$var$validateCompany;
const $70dc0a0cd1ed5f6e$var$validateAreaOfInterest = (areaOfInterest)=>{
    if (!areaOfInterest || !areaOfInterest.trim()) {
        alert("Please select how you heard about us.");
        const trigger = document.querySelector("#hearAboutSelect .custom-select-trigger");
        if (trigger) trigger.focus();
        else $70dc0a0cd1ed5f6e$var$focusField("area_of_interest");
        return false;
    }
    return true;
};
const $70dc0a0cd1ed5f6e$var$validateMessage = (message)=>{
    const trimmedMessage = message?.trim();
    if (!trimmedMessage || trimmedMessage.length < 10) {
        alert("Please enter a valid message (at least 10 characters).");
        if (!$70dc0a0cd1ed5f6e$var$focusField("project")) $70dc0a0cd1ed5f6e$var$focusField("message");
        return false;
    }
    return true;
};
const $70dc0a0cd1ed5f6e$var$validateCaptcha = ()=>{
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    if (!captchaInput) {
        alert("Please enter the CAPTCHA code shown in the image.");
        $70dc0a0cd1ed5f6e$var$focusField("captchaInput");
        return false;
    }
    return true;
};
// FORM SUBMIT
const $70dc0a0cd1ed5f6e$var$FormSubmit = async (e)=>{
    e.preventDefault();
    const submitBtn = document.getElementById("form-button");
    if (submitBtn.disabled) return;
    // Honeypot check
    const honeypot = document.getElementById("honeypot");
    if (honeypot && honeypot.value !== "") return;
    const name = document.getElementById("fullName")?.value.trim();
    const email = document.getElementById("email")?.value.trim();
    const phoneRaw = document.getElementById("Phone_number")?.value.trim();
    const companyName = document.getElementById("company_name")?.value.trim();
    const message = document.getElementById("project")?.value.trim() || "";
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    const countrySelect = document.getElementById("countryCode");
    const areaOfInterest = document.getElementById("area_of_interest")?.value || "";
    const countryCode = countrySelect?.value || "";
    // Validations
    if (!$70dc0a0cd1ed5f6e$var$validateName(name)) return;
    if (!$70dc0a0cd1ed5f6e$var$validateCountryCode(countryCode)) return;
    const cleanedPhone = $70dc0a0cd1ed5f6e$var$validatePhone(phoneRaw || "");
    if (!cleanedPhone) return;
    if (!$70dc0a0cd1ed5f6e$var$validateEmail(email)) return;
    if (!$70dc0a0cd1ed5f6e$var$validateCompany(companyName)) return;
    if (!$70dc0a0cd1ed5f6e$var$validateAreaOfInterest(areaOfInterest)) return;
    if (!$70dc0a0cd1ed5f6e$var$validateMessage(message)) return;
    if (!$70dc0a0cd1ed5f6e$var$validateCaptcha()) return;
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", cleanedPhone);
    formData.append("company_name", companyName);
    formData.append("country_code", countryCode);
    formData.append("description", message);
    formData.append("area_of_interest", areaOfInterest);
    // Captcha API values
    formData.append("captcha_0", $70dc0a0cd1ed5f6e$var$savedCaptchaCode);
    formData.append("captcha_1", captchaInput);
    // Extra fields
    formData.append("source", "contact-us");
    formData.append("user_agent", navigator.userAgent);
    try {
        const response = await fetch(`${"https://qkkalabs.com"}/blog/api/contact-us`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Form failed");
        const result = await response.json();
        // Save data
        if (result?.data?.name) localStorage.setItem("contact_name", result.data.name);
        if (result?.data?.email) localStorage.setItem("contact_email", result.data.email);
        // Redirect keep same
        window.location.href = "/thankyou";
    } catch (error) {
        console.error(error);
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
        $70dc0a0cd1ed5f6e$var$createCaptchaImage();
    }
};
window.FormSubmit = $70dc0a0cd1ed5f6e$var$FormSubmit;
// PAGE CACHE FIX
window.addEventListener("pageshow", (event)=>{
    if (event.persisted) window.location.reload();
});
// THANK YOU PAGE DATA & FORM SETUP
document.addEventListener("DOMContentLoaded", ()=>{
    const form = document.getElementById("form-button")?.closest("form");
    if (form) form.noValidate = true;
    const userName = document.getElementById("userName");
    const userEmail = document.getElementById("userEmail");
    if (userName) userName.textContent = localStorage.getItem("contact_name") || "No Name Found";
    if (userEmail) userEmail.textContent = localStorage.getItem("contact_email") || "No Email Found";
});


//# sourceMappingURL=contact-us.56c861d1.js.map
